import firebase from 'firebase/app'



export default {
  // This makes your getters, mutations, and actions accessed by, eg: 'myModule/myModularizedNumber' instead of mounting getters, mutations, and actions to the root namespace.
  namespaced: false,


  state: {
    foundFriends: [],
    friendProfile: {
      name: '',
      filter: {},
    }
  },


  getters: {
    friendProfile (state) {
      return state.friendProfile
    },
  },


  mutations: {
    delFoundFriends (state) {
      state.foundFriends = []
    },

    setFriendProfile (state, payload) {
      state.friendProfile = payload
    },
    
    setFoundFriends (state, payload) {
      if (state.foundFriends.some(obj => obj.id === payload.id)) {
        // do nothing when friend (payload.id) is already in array
      } else {
        state.foundFriends.push(payload)
      }
    },
  },
  actions: {
    // loadFriendWithID({commit}, payloadId) {
      

    //   firebase.firestore().collection('users').doc(payloadId).get()
    //     .then(function(doc) {
    //       if (doc.exists) {
    //         console.log('friendProfileData', doc.data())
    //         commit('setFriendProfile', doc.data())
    //       } else {
    //         // doc.data() will be undefined in this case
    //         console.log('No such document!')
    //       }
    //     }).catch(function(error) {
    //       console.log('Error getting document:', error)
    //     })
    // },

    loadFriend({commit}, payloadId) {
      
      console.log(payloadId)
      firebase.firestore().collection('users').where('uniqueId', '==', payloadId).get()
        .then(function(querySnapshot) {
          querySnapshot.forEach(function(doc) {
            if (doc.exists) {
              console.log('friendProfileData', doc.data())
              commit('setFriendProfile', doc.data())
            } else {
              // doc.data() will be undefined in this case
              console.log('No such document!')
            }
          })
          
        }).catch(function(error) {
          console.log('Error getting document:', error)
        })
    },


    searchNewFriends({commit}, payload) {
      let searchTerm = payload.toUpperCase()

      firebase.firestore().collection('users')
        // .where('name', '>=', payload).orderBy('name').where('name', '<=', payload + 'z').limit(50).get()
        .where('searchName', '>=', searchTerm).orderBy('searchName').where('searchName', '<=', searchTerm + 'z').limit(50).get()
        .then((querySnapshot) =>  {
          querySnapshot.forEach((doc) => {
            console.log(doc.data())
            commit('setFoundFriends', doc.data())
          })
        })
        .catch((error) => {
          console.log(error)
        })
      
        
      
    },

    searchNewFriendsUniqueId({commit}, payload) {
      let searchTerm = payload.toLowerCase()

      firebase.firestore().collection('users')
        // .where('name', '>=', payload).orderBy('name').where('name', '<=', payload + 'z').limit(50).get()
        .where('uniqueId', '>=', searchTerm).orderBy('uniqueId').where('uniqueId', '<=', searchTerm + 'z').limit(50).get()
        .then((querySnapshot) =>  {
          querySnapshot.forEach((doc) => {
            console.log(doc.data())
            commit('setFoundFriends', doc.data())
          })
        })
        .catch((error) => {
          console.log(error)
        })
      
        
      
    },

    
    

    addNewFriendsFirebase({commit}, payload) {
      commit('clearError')
      let user = firebase.auth().currentUser
      let requestTime = new Date().toISOString()
      var ownDocRef = firebase.firestore().collection('users').doc(user.uid).collection('friends').doc(payload.id)
      var friendDocRef = firebase.firestore().collection('users').doc(payload.id).collection('friends').doc(user.uid)
      var friendNotificationsRef = firebase.firestore().collection('users').doc(payload.id).collection('notifications')
      if (user) {
        // firebase.firestore().collection('users').doc(user.uid).collection('friends').doc(payloadid).set({
        //   accepted: false,
        //   requestTime: new Date().toISOString()
        // })
        //   .then(function(docRef) {
        //     console.log('Document written with ID: ', docRef, 'docRef', docRef)
          
        //   })
        //   .catch(function(error) {

        //     console.error('Error adding document: ', error)
        //   })

        // nicht ausführen, falls FriendRequest an sich selbst gestellt wird
        if (user.uid === payload.id) {

        } else {
          // create Notification (for Friend)
          friendNotificationsRef.add({
            subject: 'friendrequest',
            friendId: user.uid,
            // friendName: user.name,
            // friendProfileImg: user.profileImg,
            // friendStatus: user.status,
            // icon: 'fas fa-account',
            // title: 'Neue Freundschaftsanfrage',
            new: true,
            requestTime: requestTime
          })
            .then(function(notificRef) {
              console.log('Notification created', notificRef)

              // create FriendRequest for user and Friend
              firebase.firestore().runTransaction((transaction) => {
                return transaction.get(ownDocRef)
                  .then(sfDoc => {
                    // Falls FriendRequest bei user bereits vorhanden ist, wird nur der Zähler hochgesetzt
                    if (sfDoc.exists) {
                      console.log('Doc already exists')
                      // transaction.update(ownDocRef, {
                      //   newRequest: sfDoc.data().newRequest + 1
                      // })
                    } else {
                  
                      // FriendRequest bei user selbst eintragen
                      transaction.set(ownDocRef, {
                        friendId: payload.id,
                        acceptedByFriend: false,
                        acceptedByUser: true,
                        requestTime: requestTime,
                        requester: user.uid,
                        notificationId: notificRef.id
                        // newRequest: 0
                      })
                      // FirendRequest bei Friend eintragen
                      transaction.set(friendDocRef, {
                        friendId: user.uid,
                        acceptedByFriend: true,
                        acceptedByUser: false,
                        requestTime: requestTime,
                        requester: user.uid,
                        notificationId: notificRef.id
                        // newRequest: 0
                      })
                      
                      // set Friend in local store
                      commit('setMyFriends', {
                        friendId: payload.id,
                        uniqueId: payload.uniqueId,
                        acceptedByFriend: false,
                        acceptedByUser: true,
                        requestTime: requestTime,
                        requester: user.uid,
                        friendName: payload.name,
                        friendProfileImg: payload.profileImg,
                        friendStatus: payload.status,
                        notificationId: notificRef.id
                      })
                    }
               
                  })
                  .then(function(friendRef) {
                    console.log('Friend request created')
                  })
                  .catch(function(error) {
                    console.error('Error adding request', error)
                  })
              })
            })
            .catch(function(error) {
              console.error('Error adding notification', error)
            })
        }
      }

      
      
    },

    cancelFriendRequest({commit, dispatch, rootState}, payloadId) {
      commit('clearError')
      let user = firebase.auth().currentUser
      let notificationId = rootState.user.myFriends.find(friend => friend.friendId === payloadId).notificationId
      let requesterId = rootState.user.myFriends.find(friend => friend.friendId === payloadId).requester

      console.log('notificationId', rootState.user.myFriends.find(friend => friend.friendId === payloadId).notificationId)
      console.log('requesterId', rootState.user.myFriends.find(friend => friend.friendId === payloadId).requester)
      var ownDocRef = firebase.firestore().collection('users').doc(user.uid).collection('friends').doc(payloadId)
      var friendDocRef = firebase.firestore().collection('users').doc(payloadId).collection('friends').doc(user.uid) 
      var friendNotificationsRef = firebase.firestore().collection('users').doc(payloadId).collection('notifications').doc(notificationId)

      if (user) {
      
        // nicht ausführen, falls CancelFriendRequest an sich selbst gestellt wird
        if (user.uid === payloadId) {

        } else {

          firebase.firestore().runTransaction((transaction) => {
            return transaction.get(ownDocRef)
              .then(sfDoc => {
                // FriendRequest und Notifiction löschen
                if (sfDoc.exists) {
                  transaction.delete(ownDocRef)
                  transaction.delete(friendDocRef)
                  if (user.uid === requesterId) {
                    transaction.delete(friendNotificationsRef)
                  } else {
                    var index = rootState.user.notifications.findIndex(not => not.notificationId === notificationId)
                    var notificationNew = rootState.user.notifications[index].new
                    if (notificationNew === true) {
                      console.log('changeNotificationByCancelRequest')
                      var notificationPayload = {
                        notificationId: notificationId
                      }
                      dispatch('changeNotification', notificationPayload)
                    }
                  }
                  commit('removeFriend', payloadId)
                } else {
              
                  
                  // commit('setMyFriends', {
                  //   id: payloadId,
                  //   accepted: false,
                  //   requestTime: new Date().toISOString(),
                  //   requester: user.uid,
                  //   newRequest: 0
                  // })
                }
           
              })
              .then(function(docRef) {
                console.log('Document written with ID: ', docRef, 'docRef', docRef)
            
              })
              
              .catch(function(error) {
  
                console.error('Error adding document: ', error)
              })
          })
            
            
        }
      }
    },
    
    acceptFriendRequest({commit, dispatch, rootState}, payload) {
      commit('clearError')
      let user = firebase.auth().currentUser
      var ownDocRef = firebase.firestore().collection('users').doc(user.uid).collection('friends').doc(payload.friendId)
      var friendDocRef = firebase.firestore().collection('users').doc(payload.friendId).collection('friends').doc(user.uid)
      if (user) {
       

        // nicht ausführen, falls FriendRequest an sich selbst gestellt wird
        if (user.uid === payload.friendId) {

        } else {
          // Get a new write batch
          var batch = firebase.firestore().batch()

          // FriendRequest bei user selbst auf accept setzen
          batch.update(ownDocRef, {
            acceptedByFriend: true,
            acceptedByUser: true
          })

          // FriendRequest bei Friend auf accept setzen
          batch.update(friendDocRef, {
            acceptedByFriend: true,
            acceptedByUser: true
          })


          // Commit the batch
          batch.commit().then(function () {
            // ...
            console.log('Accepted')

            // change Notifications to 'read'
            var index = rootState.user.notifications.findIndex(not => not.notificationId === payload.notificationId)
            var notificationNew = rootState.user.notifications[index].new
            if (notificationNew === true) {
              console.log('changeNotificationByAccept')
              dispatch('changeNotification', payload)
            }


            commit('removeFriend', payload.friendId)

            commit('setMyFriends', {
              friendId: payload.friendId,
              uniqueId: payload.uniqueId,
              acceptedByFriend: true,
              acceptedByUser: true,
              requester: user.uid,
              requestTime: payload.requestTime,
              friendName: payload.friendName,
              friendProfileImg: payload.friendProfileImg,
              friendStatus: payload.friendStatus,
              notificationId: payload.notificationId
            })
          })




            
            
        }
      }
    },
  
    //   autoSignIn({commit}, payload) {
    //     commit('setLoading', true)
    //     commit('clearError')

    //     console.log('startAutoSignin', payload)

    //     if ( payload.emailVerified ) {
    //       console.log('emailIstVerifiziert -> Datenbankzugriff')
    //       commit('delIsNotVerified')

    //       firebase.firestore().collection('users').doc(payload.uid).get()
    //         .then((userdoc) => {
    //           const obj = userdoc.data()
    //           const loggedInUser = {
    //             id: payload.uid,
    //             email: obj.email,
    //             name: obj.name,
    //             birthday: obj.birthday,
    //             location: obj.location,
    //             events: obj.events,
    //             moments: obj.moments,
    //             profileImg: obj.profileImg,
    //             status: obj.status,
    //             categories: obj.categories,
    //             nameChanged: obj.nameChanged,
    //           }
    //           commit('setUser', loggedInUser)
    //           commit('setLoading', false)

    //         })
    //         .catch((error) => {
    //           console.log('UserLoginError2', error)
    //           commit('setLoading', false)
    //           commit('setError', error)
    //         })
    //     } else {
    //       console.log('emailIstNichtVerifiziert')

    //       commit('setIsNotVerified', payload.email)
    //       commit('setRefreshLoading', false)
    //       commit('setLoading', false)

    //     }
      
  //   },
  }
}